import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { AndParallelExpression } from "../../../Models/Logical/AndParallelExpression";

export class AndParallelExpressionEvaluator implements IExpressionEvaluator<AndParallelExpression> {
  get type(): string {
    return "AndParallel";
  }

  // Evaluates all values in parallel and returns the first falsy value or true if all are truthy.
  evaluate(expression: AndParallelExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const results = expression.Value.map((expr) => context.Evaluator.evaluate(expr, context));

    // Check if any results are promises
    const hasPromises = results.some((r) => r instanceof Promise);

    if (hasPromises) {
      // Execute all in parallel
      return Promise.all(results).then((resolvedResults) => this.findFirstFalsyOrTrue(resolvedResults));
    }

    // All synchronous
    return this.findFirstFalsyOrTrue(results);
  }

  private findFirstFalsyOrTrue(results: any[]): any {
    for (const result of results) {
      if (!result) {
        return result;
      }
    }
    return true;
  }
}
